import { render, staticRenderFns } from "./traineeMaterialsApproval.vue?vue&type=template&id=59b28e5a&scoped=true"
import script from "./traineeMaterialsApproval.vue?vue&type=script&lang=js"
export * from "./traineeMaterialsApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b28e5a",
  null
  
)

export default component.exports